import React, { FC, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { navigationLeft } from 'config/navigationLeft';
import { useLocation } from 'react-router-dom';
import {
  NavSublist,
  StyledLink,
  NavHeader,
  NavList,
  Summary,
  MobileLeftNavContainer,
  LeftNavContainer,
  SignOutButton,
} from './LeftNavigation.style';
import useMedia from 'hooks/useMedia';
import { useGlobalProvider } from 'components/common/GlobalVisualProvider';
import { useOutsideClickCallback } from 'utils/uiHelpers';

export const LeftNavigation: FC = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const [parentItemActive, setParentItemActive] = useState<string | null>(null);
  const { leftNavOpen, setLeftNavOpen, openLogoutModal } = useGlobalProvider();
  const isMobile = useMedia('(max-width: 62rem)');

  const LeftNavContainerComponent = isMobile
    ? MobileLeftNavContainer
    : LeftNavContainer;
  const renderOption = (option, isChild = false) => {
    const isActiveLink = location?.pathname?.includes(option?.linkPath);
    if (option.menuOptions) {
      // if some of the child link is active, keep nav menu open
      const isChildLinkActive = option.menuOptions?.some(item =>
        location?.pathname?.includes(item?.linkPath)
      );
      return (
        <details
          open={
            parentItemActive === option.name ||
            isChildLinkActive ||
            isActiveLink
          }>
          <Summary
            onClick={() => {
              setParentItemActive(option.name);
            }}
            tabIndex={-1}>
            <StyledLink
              end
              to={option.linkPath}
              className={({ isActive }) =>
                'nav-link' + (isActive ? ' active' : '')
              }>
              {t(option.linkTextKey)}
            </StyledLink>
          </Summary>
          <NavSublist>
            {option.menuOptions.map(menuOption => {
              return renderOption(menuOption, true);
            })}
          </NavSublist>
        </details>
      );
    }

    const clickHandler = () => {
      if (!isChild) setParentItemActive(option.name);

      setLeftNavOpen(false);
    };

    return (
      <li key={option.name} onClick={clickHandler}>
        <StyledLink
          to={option.linkPath}
          className={({ isActive }) =>
            'nav-link' + (isActive ? ' active' : '')
          }>
          {t(option.linkTextKey)}
        </StyledLink>
      </li>
    );
  };

  const wrapperRef = useRef(null);
  useOutsideClickCallback(wrapperRef, () => setLeftNavOpen(false));

  return (
    <LeftNavContainerComponent
      {...(isMobile ? { ref: wrapperRef, isOpen: leftNavOpen } : {})}>
      <NavList>
        <NavHeader as='a' href='/'>
          {t('leftNav.myAccount')}
        </NavHeader>
        {navigationLeft.map(option => {
          return <div key={option.name}>{renderOption(option)}</div>;
        })}
      </NavList>
      <SignOutButton
        onClick={() => {
          setLeftNavOpen(false);
          openLogoutModal();
        }}>
        {t('header.signout')}
      </SignOutButton>
    </LeftNavContainerComponent>
  );
};
